import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const eventScheduleImporterSelectors = importerSelectors(
  'eventSchedule.importer',
);

export default eventScheduleImporterSelectors;
